export default function ({ store }) {
  if (
    !store.getters['auth/isAuthenticatedGetter'] ||
    !store.getters['auth/isTeacherGetter']
  ) {
    return {
      name: 'LoginTeacher'
    }
  }
  return false
}
